<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="queenPurchaseForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :has-import="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="queenPurchase" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                queenPurchaseForm: () => import('../forms/QueenPurchaseForm'),
                queenPurchase: () => import('../editViews/QueenPurchase'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Seller Name', value: 'sellerName' },
                    { text: 'On', value: 'on', format: this.formatDate },
                    { text: 'Number Of Queens', value: 'numberOfQueens' },
                    { text: 'Are Queens Healthy', value: 'areQueensHealthy' },
                    { text: 'Invoice File', value: 'invoiceFileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    files: [],
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "on", direction: "descending" },
                    { column: "sellerName", direction: "ascending" },
                    { column: "memberId", direction: "ascending" },
                ],
                itemsField: 'queenPurchases',
                editPageName: 'queenPurchase',
                apiMethod: 'QueenPurchases',
                claimName: 'QueenPurchases',
                formTitle: 'Queen Purchase',
                excelTitle: 'Queen Purchases',
                hasEditPage: true,
            }
        },
    };
</script>
